<template>
	<div :debugid="this.data.id" class="attachment-file-item">

        <div class="attachment-item--container">
			<div class="icon-container">
				<v-icon>insert_drive_file</v-icon>
			</div>

			<div v-if="data.doPreview" class="preview-container">
				<v-img container :src="data.preview"></v-img>
			</div>
			<div class="content-container">
				<h4 ref="contentTitle" class="content-title">
					{{ data.filename || data.file.name ||  data.file.filename }}
				</h4>
				<div>
					<p class="caption"><span>{{ getFileUsageSubType }} </span>{{ getAttachmentAnnotation }}</p>
				</div>
			</div>
			<div
				v-if="canRemove" 
				class="actions-container">
				<div
					class="item-prop item-actions">
					<v-tooltip
						top
						open-delay="400">
						<v-icon
							slot="activator"
							size="16px"
							class="item-action"
							@click.stop="removeAttachment">
							cancel</v-icon>
						<span class="grey--text text--lighten-3">Remove</span>
					</v-tooltip>
				</div>	
			</div>



		</div>
		<div
			v-if="data.status == $store.state.constants.SILA_FILE_UPLOAD_STATUS_STARTED" 
			class="attachment-item--preloader">
			<div class="preloader--ind" :style="fileProgress"></div>
		</div>
	</div>
</template>

<script>
	import { mapState, mapGetters } from 'vuex'

	import { VUEX_ATTACHMENTS_DELETE_ATTACHMENT } from '@/store/constants/attachments'

	export default {
		name: 'attachment-file-item',

		props: {
			data: {
				type: Object,
				required: true,
				default: null
			},

			removeDispatchEvent: {
				type: [Function, Promise],
				required: false,
				default: null
			},
		},

		computed: {	
			...mapGetters({
				getJobEnumItemValueByKey: 'getJobEnumItemValueByKey',
			}),	

			fileProgress() { 
				let total = this.data.progress.total
				let loaded = this.data.progress.loaded
				
				if(!total) return 0
				return { transform:'scaleX(' + loaded/total + ')' }
			},

			getFileUsageSubType() {
				
				if (this.data.file || this.data.usage_sub_type) {
					let sub_type = this.data.file 
						? this.data.file.usage_sub_type 
						: this.data.usage_sub_type 
							? this.data.usage_sub_type 
							: null
					let sub_type_name = this.getJobEnumItemValueByKey('fileJobAttachmentSubtypes', sub_type, 'value', 'name')
					if (sub_type_name) return sub_type_name
				} 

				switch(this.data.usage_type) {
					case SILA_FILE_USAGE_TYPE_FTP_URL :
						return 'FTP'
						break

					default :
						return ''
						break
				}
			},

			getAttachmentAnnotation() {
				return this.data.note ? this.data.note : ''
			},

			canRemove() {
				if (this.data.usage_type == SILA_FILE_USAGE_TYPE_FTP_URL) return true

				return (this.data.status == SILA_FILE_PROCESSING_STATUS_SUCCESS ||
						this.data.file.upload_status == SILA_FILE_UPLOAD_STATUS_SUCCESS) ? true : false
			}
		},

		mounted() {

		},

		methods: {
			removeAttachment() {
				if (this.removeDispatchEvent) {
					this.removeDispatchEvent(this.data) 
				} else {
					console.error("Attachment_File_Item -> removeAttachment(): You must pass a 'removeDispatchEvent' to remove the item.")
				}
			}
		}
	}
</script>